export const passwordInitialValues = () => {
    return ({
        password: "",
        confirmPassword: "",
    });
};
